import {createApp} from 'vue'
import App from './App.vue'
import axios from 'axios'

//globals
import InlineSvg from 'vue-inline-svg'

//state
import {store} from './store'

//routes
import router from './router'

//templates
import Generic from "@/components/pages/Generic"
import Home from "@/components/pages/Home"
import Careers from "@/components/pages/Careers"
import Community from "@/components/pages/Community"
import Games from "@/components/pages/Games"
import News from "@/components/pages/News"
import NotFound from "@/components/pages/NotFound"

//GLOBAL CONFIG
let craftApiPreviewToken = ''
if (window.siteConfig?.xCraftLivePreview) {
    // do not start with ? or &
    craftApiPreviewToken = 'tokenParam=' + window.siteConfig?.xCraftLivePreview + '&token=' + window.siteConfig?.xCraftLivePreviewToken
}
window.config = {
    metaTitleAddon: "Insomniac Games",
    loadedOnce: false,
    routerInTransition: false,
    apiroot: process.env.VUE_APP_API,
    apirootActions: process.env.VUE_APP_API_ACTIONS,
    craftApiPreviewToken: craftApiPreviewToken,
    skipPreview: false,
    //skipPreview: (process.env.VUE_APP_API === 'https://ZZinsomniac.ddev.site/feed/' || window.siteConfig?.xCraftLivePreview),
    json: {
        global: null,
        artifacts: null
    },
}

axios.get((`${window.config.apiroot}artifacts/?${craftApiPreviewToken}`))
    .then((res) => {
        window.config.json.artifacts = res.data.artifacts
        startApp0();
    }).catch(() => {
})


function startApp0 () {
    axios.get((`${window.config.apiroot}global/?${craftApiPreviewToken}`))
        .then((res) => {
            //GLOBAL CONFIG
            window.config.json.global = res.data

            //DYNAMIC ROUTES
            for (let i = 0; i < res.data.routes.length; i++) {
                let obj = res.data.routes[i]
                let newobj = {
                    path: obj.path,
                    meta: {
                        title: obj.title,
                        type: obj.type,
                    },
                }
                switch (obj.type) {
                    case 'home':
                        newobj.component = Home
                        break
                    case 'generic':
                        newobj.component = Generic
                        break
                    case 'careers':
                        newobj.component = Careers
                        break
                    case 'community':
                        newobj.component = Community
                        break
                    case 'games':
                        newobj.component = Games
                        break
                    case 'news':
                        newobj.component = News
                        break
                }
                router.addRoute(newobj)
            }

            //page not found
            let newobj = {
                name: 'page-not-found',
                path: "/:catchAll(.*)",
                component: NotFound,
                meta: {
                    title: 'Page Not Found'
                }
            }
            router.addRoute(newobj)

            //START APP
            startApp()
        }).catch(() => {
    })
}
function startApp () {
    //LOAD
    const app = createApp(App)
    app.use(router)
    app.use(store)

    // global inline svg
    app.component('inline-svg', InlineSvg)

    app.mount('#app')
}
